import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  formTargetConnected(element) {
    setTimeout(() => {
      const errorField = Array.from(
        document.querySelectorAll(".field_with_errors")
      )[0];
      if (errorField) {
        window.scrollTo({
          top: errorField.getBoundingClientRect().top - 100,
          left: 0,
          behavior: "smooth",
        });
      }
    }, 50);
  }
}
